import styled from "styled-components";
import { FC } from "react";
import Skeleton from "components/Skeleton";
import { Text } from "@chakra-ui/layout";

export interface ItemDetailProps {
  label: string;
  value?: string;
}

const ItemDetail: FC<ItemDetailProps> = ({ label, value, children }) => {
  const textValue = value && (
    <div>
      <Text m={0} fontWeight="bold">
        {value}
      </Text>
    </div>
  );

  const valueNode = children || textValue;

  return (
    <Box>
      <div>
        <Text textTransform="uppercase">{label}:</Text>
      </div>

      {valueNode !== undefined ? valueNode : <Skeleton />}
    </Box>
  );
};

const Box = styled.div`
  margin: 14px 0;
  padding-Right: 170px
  
`;

export default ItemDetail;
